export default __webpack_public_path__ + "static/media/150w.19cd6fd4.svg";